import React, {PropsWithChildren, useEffect} from "react";
import {setProject, setSport} from "modules/actions";
import {Project, Sport} from "modules/types";
import {useDispatch} from "react-redux";

interface IProps {
	sport: Sport;
	project: Project;
}

export const HOCSportSelect: React.FC<PropsWithChildren<IProps>> = ({sport, project, children}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setSport(sport));
		dispatch(setProject(project));
	}, [dispatch, sport, project]);

	return <React.Fragment>{children}</React.Fragment>;
};
